import { convertISOToPhDate } from '~shared/lib/convert-date';

import type { PersonDataResponse } from '../../model';
import type { BasicInfoFormValues } from '../../model/schemas';

export function recoverBasicInfo(
  dto: PersonDataResponse
): Partial<BasicInfoFormValues> {
  return {
    firstName: dto?.firstName ?? '',
    middleName: dto?.middleName ?? '',
    lastName: dto?.lastName ?? '',
    dateOfBirth: dto?.birthDate ? convertISOToPhDate(dto.birthDate) : '',
    email: dto?.email ?? '',
    pointOfContact: dto?.pointOfContact ?? '',
  };
}
